<template>
  <div data-ac-actions-container class="ac-action-container">
    <span class="ac-actions-title content">
      {{ $t('page.active_conversation.different_issue', { appName }) }}
    </span>

    <!-- <span class="ac-actions-remaining content">
      $t('page.active_conversation.remaining', { maxLimit: maxLimit })
    </span> -->

    <ThemeButton
      v-track-click="BTN_EVTS.ACTIVE_CONVERSATION_NEW_CONVERSATION"
      data-ac-action
      class="ac-action"
      :class="disabled && 'disabled'"
      :disabled="disabled"
      @click="!disabled && $emit('new')"
    >
      {{ $t('page.active_conversation.new') }}
    </ThemeButton>
  </div>
</template>

<script lang="ts">
import ThemeButton from '@/components/ThemeButton.vue';
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as env from '@/common/environment';
import trackClick, { BTN_EVTS } from '@/directives/trackClick';

@Component({ components: { ThemeButton }, directives: { trackClick } })
export default class ACActions extends Vue {
  @Prop(Boolean) readonly disabled!: boolean;
  @Prop({ default: 'x' }) readonly maxLimit!: string | number;

  readonly BTN_EVTS = BTN_EVTS;

  appName = env.get('appName');
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/base.scss';
.ac-action-container {
  box-shadow: 0 -3px 5px 0 rgba(0, 0, 0, 0.15);
  padding: 20px;
  text-align: center;
  background-color: $action-sheet-background;

  .content {
    display: block;
    color: $action-sheet-text-color;
    font-size: $size-m2;
    font-weight: 400;
  }

  .ac-action {
    font-size: $size-m2;
    padding: 0.8rem 7rem;
    margin-top: 10px;
    cursor: pointer;
  }
}
</style>
